import {
  DetailsViewSidebar,
  DetailsViewSidebarTabs as SidebarTabs,
  DetailsViewSidebarTabsList as SidebarTabsList,
  DetailsViewSidebarTabsPanel as SidebarTabsPanel,
  DetailsViewSidebarTabsTab as SidebarTabsTab,
  DetailsViewSidebarUpper as SidebarUpper,
} from 'components/shared';
import { AttachmentIcon, ShareIcon } from 'icons';
import { useTranslation } from 'react-i18next';

import { Attachments } from './Attachments';
import { GeneralSettings } from './GeneralSettings';
import { Sharing } from './Sharing';
import { UpperSection } from './UpperSection';

export const Sidebar = () => {
  const { t } = useTranslation('forms');

  const TABS = [
    {
      label: t('editView.sidebar.tabs.general'),
      value: 'general',
      panel: <GeneralSettings />,
    },
    {
      icon: <AttachmentIcon />,
      label: t('editView.sidebar.tabs.attachments'),
      value: 'attachments',
      panel: <Attachments />,
    },
    {
      icon: <ShareIcon />,
      label: t('editView.sidebar.tabs.sharing'),
      value: 'sharing',
      panel: <Sharing />,
    },
  ];

  return (
    <DetailsViewSidebar>
      <SidebarUpper title={t('editView.sidebar.details')}>
        <UpperSection />
      </SidebarUpper>
      <SidebarTabs defaultValue={TABS[0].value}>
        <SidebarTabsList>
          {TABS.map(({ label, value, icon }) => (
            <SidebarTabsTab key={value} value={value} Icon={icon}>
              {label}
            </SidebarTabsTab>
          ))}
        </SidebarTabsList>
        {TABS.map(({ value, panel }) => (
          <SidebarTabsPanel key={value} value={value}>
            {panel}
          </SidebarTabsPanel>
        ))}
      </SidebarTabs>
    </DetailsViewSidebar>
  );
};
